/**
 * assets/ssuk-vat.js                                      SSUK, 20 Sept 2026
 *
 * The site-wide ex VAT / inc VAT price toggle. Default is ex VAT (Sam, 20 Sept).
 *
 * HOW IT WORKS, and why this way
 * Every SSUK surface already prints BOTH figures into the markup. So the toggle
 * does not fetch, re-render or rewrite any price - it sets one class on <html>
 * and CSS hides the half you are not looking at. That means:
 *   - it is instant, with no layout shift and no flash of the wrong number
 *   - it survives Shopify's full-page cache, because nothing is server-rendered
 *     per visitor
 *   - it cannot ever show a stale or miscalculated figure, because it never
 *     does arithmetic - both numbers come from Liquid
 *
 * The class is set by a tiny inline script in doc-head-core.liquid, before
 * first paint. This file only builds the control and handles interaction.
 *
 * Preference is per browser (localStorage), shared across tabs via the storage
 * event. It is deliberately NOT a cookie: a cookie would vary cached pages.
 */
(function () {
  'use strict';

  var KEY = 'ssuk-vat-mode';
  var MODES = { ex: 'ex', inc: 'inc' };
  var DEFAULT = MODES.ex;

  function read() {
    try { return localStorage.getItem(KEY) === MODES.inc ? MODES.inc : DEFAULT; }
    catch (e) { return DEFAULT; }
  }

  function apply(mode) {
    var root = document.documentElement;
    root.classList.toggle('ssuk-vat-ex', mode === MODES.ex);
    root.classList.toggle('ssuk-vat-inc', mode === MODES.inc);
    root.setAttribute('data-ssuk-vat', mode);
    var btns = document.querySelectorAll('[data-ssuk-vat-btn]');
    for (var i = 0; i < btns.length; i++) {
      var on = btns[i].getAttribute('data-ssuk-vat-btn') === mode;
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    /* Anything that needs to recalculate (the quote builder totals) can listen. */
    document.dispatchEvent(new CustomEvent('ssuk:vat-mode', { detail: { mode: mode } }));
  }

  function set(mode) {
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    apply(mode);
  }

  function control(variant) {
    var wrap = document.createElement('div');
    wrap.className = 'ssuk-vat ssuk-vat--' + variant;
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Show prices excluding or including VAT');

    var label = document.createElement('span');
    label.className = 'ssuk-vat__label';
    label.textContent = 'Prices';
    wrap.appendChild(label);

    var group = document.createElement('span');
    group.className = 'ssuk-vat__group';

    [['ex', 'ex VAT'], ['inc', 'inc VAT']].forEach(function (pair) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ssuk-vat__btn';
      b.setAttribute('data-ssuk-vat-btn', pair[0]);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = pair[1];
      b.addEventListener('click', function () { set(pair[0]); });
      group.appendChild(b);
    });

    wrap.appendChild(group);
    return wrap;
  }

  function mount() {
    if (document.querySelector('.ssuk-vat')) return;

    /* Desktop: the announcement bar's right column, beside Trade Account.
       That column is "hidden md:flex", so it never shows on a phone. */
    var right = document.querySelector('.announcement__col--right');
    if (right) right.appendChild(control('bar'));

    /* Mobile: its own compact row, injected after the announcement bar so it
       is present on every page without touching header.liquid (84KB). */
    var bar = document.querySelector('announcement-bar');
    if (bar && bar.parentNode) {
      var mob = document.createElement('div');
      mob.className = 'ssuk-vat-mobile';
      mob.appendChild(control('mobile'));
      bar.parentNode.insertBefore(mob, bar.nextSibling);
    }

    apply(read());
  }

  /* Another tab changed it. */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) apply(read());
  });

  /* Sections re-render on filter, variant change and cart update; the <html>
     class survives all of those, so only the control needs re-checking. */
  document.addEventListener('shopify:section:load', mount);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
}());
